import { Box } from '@mui/material';
import { VISUALLY_HIDDEN } from '../../constants';

/** Marks a skeleton container as a busy live region, so screen readers announce the loading state. */
export const LOADING_STATUS_PROPS = { role: 'status', 'aria-busy': true } as const;

/**
 * Visually hidden loading text, read by screen readers inside a `LOADING_STATUS_PROPS` container.
 *
 * @param {string} label - The text announced to assistive technologies.
 *
 * @return {React.JSX.Element} The rendered LoadingStatusText component.
 */
export const LoadingStatusText = ({ label = 'Cargando…' }: { label?: string }) => (
  <Box component="span" sx={VISUALLY_HIDDEN}>
    {label}
  </Box>
);
